export default __webpack_public_path__ + "static/media/logo-v2.255b6649.png";